// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logout {
  display: flex;
  justify-content: center;
  align-items: center;
}

.invalid-feedback {
  font-size: 12px;
  font-weight: 400;
}

.form-check {
  font-size: 12px;
  font-weight: 400;
  color: #1a1a1a;
}

.register-link {
  margin-top: 10px;
}

.password-note {
  color: var(--gray-500, #718096);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.00075rem;
  margin-bottom: 20px !important;
  margin-top: 10px !important;
}

.input-group-text {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}
.input-group-text.is-valid {
  border-left: none;
  border-top: 1px solid #319795 !important;
  border-right: 1px solid #319795 !important;
  border-bottom: 1px solid #319795 !important;
}
.input-group-text.is-invalid {
  border-left: none;
  border-top: 1px solid #dc3545 !important;
  border-right: 1px solid #dc3545 !important;
  border-bottom: 1px solid #dc3545 !important;
}

.register-form-card {
  height: auto;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.0784313725);
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.0509803922);
  width: 95vw;
  display: flex;
  justify-content: center;
  background-color: white;
  margin-top: 20px;
  margin-bottom: 20px;
}
.register-form-card .form-label {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}
.register-form-card .point {
  width: 19% !important;
  height: 2px !important;
}
.register-form-card #strengthBar {
  margin-bottom: 0px;
}
.register-form-card .register-form {
  width: 40%;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: calc(100vh - 100px);
}

.title-registration {
  font-size: 29px;
  font-weight: 500;
  color: #2d3748;
}

#register-device {
  font-size: 22px;
  font-weight: 500;
  color: #2d3748;
}

.login-form-card {
  height: auto;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  padding-right: 65px;
  padding-left: 65px;
  padding-top: 20px;
  padding-bottom: 40px;
  border: 1px solid rgba(0, 0, 0, 0.0784313725);
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.0509803922);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.login-form-card .point {
  width: 72px !important;
  height: 2px !important;
}
.login-form-card #login-form {
  width: 370px;
}
.login-form-card .input-group:not(.has-validation) > .password-input {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.login-form-card .form-switch .form-check-input {
  margin-right: 5px;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}
.login-form-card .login-error {
  color: #ff2c20;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
  margin-top: -10px;
}
.login-form-card .login-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.login-form-card .form-label {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}
.login-form-card .invalid-feedback {
  font-size: 12px;
  font-weight: 400;
}
.login-form-card .form-check {
  font-size: 12px;
  font-weight: 400;
  color: #1a1a1a;
}
.login-form-card .sign-in {
  margin-top: 40px;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  padding-left: 40px;
  padding-right: 40px;
}
.login-form-card .sign-in .btn {
  background-image: linear-gradient(#08625f, #439a97);
}
.login-form-card .sign-in .btn:hover {
  background-image: linear-gradient(#339b9d, #339b9d);
}
.login-form-card .register-account {
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 15px;
}

.confirmation-modal .modal-content {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.confirmation-box {
  width: 277px;
  height: 266px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.confirmation-box .confirmation-icon-box {
  width: 100%;
  height: 133px;
  background: #08625f;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.confirmation-box .confirmation-message-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 133px;
  flex-direction: column;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.confirmation-box .confirmation-message {
  font-size: 0.75rem;
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/login/login.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AAGF;;AADA;EACE,uCAAA;EACA,0CAAA;AAIF;AAHE;EACE,iBAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;AAKJ;AAHE;EACE,iBAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;AAKJ;;AAFA;EAaE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,6CAAA;EACA,uDAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAPF;AAjBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAmBJ;AAjBE;EACE,qBAAA;EACA,sBAAA;AAmBJ;AAjBE;EACE,kBAAA;AAmBJ;AAHE;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;AAKJ;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAKF;;AAHA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAMF;;AAHA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6CAAA;EACA,uDAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAMF;AALE;EACE,sBAAA;EACA,sBAAA;AAOJ;AALE;EACE,YAAA;AAOJ;AAJE;EACE,uCAAA;EACA,0CAAA;AAMJ;AAHE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAKJ;AAHE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAKJ;AAHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAKJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAIJ;AAFE;EACE,eAAA;EACA,gBAAA;AAIJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAIJ;AADE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;AAFI;EACE,mDAAA;AAIN;AAHM;EACE,mDAAA;AAKR;AADE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AAEE;EACE,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;AACJ;;AAEA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+CAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AAEJ;AAAE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAEJ;AAAE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ","sourcesContent":["$hover-color: #339b9d;\n\n.logout {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.invalid-feedback {\n  font-size: 12px;\n  font-weight: 400;\n}\n.form-check {\n  font-size: 12px;\n  font-weight: 400;\n  color: #1a1a1a;\n}\n.register-link {\n  margin-top: 10px;\n}\n.password-note {\n  color: var(--gray-500, #718096);\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.00075rem;\n  margin-bottom: 20px !important;\n  margin-top: 10px !important;\n}\n.input-group-text {\n  border-top-right-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n  &.is-valid {\n    border-left: none;\n    border-top: 1px solid #319795 !important;\n    border-right: 1px solid #319795 !important;\n    border-bottom: 1px solid #319795 !important;\n  }\n  &.is-invalid {\n    border-left: none;\n    border-top: 1px solid #dc3545 !important;\n    border-right: 1px solid #dc3545 !important;\n    border-bottom: 1px solid #dc3545 !important;\n  }\n}\n.register-form-card {\n  .form-label {\n    font-size: 12px;\n    font-weight: 400;\n    color: #333333;\n  }\n  .point {\n    width: 19% !important;\n    height: 2px !important;\n  }\n  #strengthBar {\n    margin-bottom: 0px;\n  }\n  height: auto;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: center;\n  border: 1px solid #00000014;\n  box-shadow: 0px 0px 0px 1px #0000000d;\n  width: 95vw;\n  display: flex;\n  justify-content: center;\n  background-color: white;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  .register-form {\n    width: 40%;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    min-height: calc(100vh - 100px);\n  }\n}\n.title-registration {\n  font-size: 29px;\n  font-weight: 500;\n  color: #2d3748;\n}\n#register-device {\n  font-size: 22px;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.login-form-card {\n  height: auto;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n  padding-right: 65px;\n  padding-left: 65px;\n  padding-top: 20px;\n  padding-bottom: 40px;\n  border: 1px solid #00000014;\n  box-shadow: 0px 0px 0px 1px #0000000d;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  .point {\n    width: 72px !important;\n    height: 2px !important;\n  }\n  #login-form {\n    width: 370px;\n  }\n\n  .input-group:not(.has-validation) > .password-input {\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n  }\n\n  .form-switch .form-check-input {\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n    margin-top: -2px;\n  }\n  .login-error {\n    color: #ff2c20;\n    font-weight: 400;\n    font-size: 14px;\n    letter-spacing: 0.5px;\n    margin-bottom: 20px;\n    margin-top: -10px;\n  }\n  .login-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n  }\n\n  .form-label {\n    font-size: 12px;\n    font-weight: 400;\n    color: #333333;\n  }\n  .invalid-feedback {\n    font-size: 12px;\n    font-weight: 400;\n  }\n  .form-check {\n    font-size: 12px;\n    font-weight: 400;\n    color: #1a1a1a;\n  }\n\n  .sign-in {\n    margin-top: 40px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #ffffff;\n    padding-left: 40px;\n    padding-right: 40px;\n    .btn {\n      background-image: linear-gradient(#08625f, #439a97);\n      &:hover {\n        background-image: linear-gradient($hover-color, $hover-color);\n      }\n    }\n  }\n  .register-account {\n    padding-left: 40px;\n    padding-right: 40px;\n    margin-top: 15px;\n  }\n}\n\n.confirmation-modal {\n  .modal-content {\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n.confirmation-box {\n  width: 277px;\n  height: 266px;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  .confirmation-icon-box {\n    width: 100%;\n    height: 133px;\n    background: #08625f;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n  }\n  .confirmation-message-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 133px;\n    flex-direction: column;\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n  }\n  .confirmation-message {\n    font-size: 0.75rem;\n    color: #2d3748;\n    font-weight: 500;\n    margin-bottom: 20px;\n    padding-left: 40px;\n    padding-right: 40px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
